import React, { useContext, useEffect, useState } from "react";
import "./Profile.css";
import { UserDetail, UpdateUserProfile } from "../../api/userApi/UserProfile";
import accountSvg from "../../assets/icons/account.svg";
import imageCompression from "browser-image-compression";
import { validateForm } from "../../app/components/FormValidator/FormValidator";
import { User } from "lucide-react";
import DOMPurify from "dompurify";
import { toast } from "react-toastify";
import UserContext from "../../context/UserContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { ChangePasswordByOldPassword } from "../../api/authApi/loginReq";
import checkPasswordStrength from "../auth/PasswordValidator";
import ConfirmModal from "../../app/components/WarningModel/ConfirmModel";
function Profile() {
  const UserId = Number(localStorage.getItem("UserId"));
  const [isUpdated, setIsUpdated] = useState(false);
  const [showPasswordStatus, setShowPasswordStatus] = useState(false);
  const { setIsProfileUpdated } = useContext(UserContext);
  const [userData, setUserData] = useState({
    UserId: UserId || Number(localStorage.getItem("UserId")),
    UserName: "Not Available",
    Email: "Not Available",
    PhoneNumber: null,
    ProfileImage: null,
    Role: "Not Available",
  });
  const [isProcessing, setisProcessing] = useState(false);
  const [passwordStatus, setPasswordStatus] = useState({
    msg: null,
    result: null,
    color: null,
  });
  const [StatusConfirmPassword, setStatusConfirmPassword] = useState({
    msg: null,
    result: null,
    color: null,
  });

  const [formErrors, setFormErrors] = useState({
    UserName: "",
    Email: "",
    PhoneNumber: "",
  });
  const [changePasswordData, setChangePasswordData] = useState({
    currentPassword: "",
    newPassword: "",
    confirmNewPassword: "",
  });

  const [showPasswordVisibility, setShowPasswordVisibility] = useState({
    showCurrentPassword: false,
    showConfirmPassword: false,
    showNewPassword: false,
  });

  const [isChangePasswordModalOpen, setIsChangePasswordModalOpen] = useState(false);
  const [showWarningModal, setshowWarningModal] = useState(false);
  useEffect(() => {
    if (UserId) {
      getUserData();
    }
  }, [isUpdated]);

  const getUserData = async () => {
    try {
      const payload = { userId: UserId };
      const response = await UserDetail(payload);

      if (response?.data?.result === 1) {
        const result = response.data.result_value;

        const roleName =
          result.roleId === 1
            ? "Admin"
            : result.roleId === 3
              ? "SuperAdmin"
              : "User";

        setUserData({
          UserId: UserId,
          UserName: result.userName || "Not Available",
          Email: result.email || "Not Available",
          PhoneNumber: result.phoneNumber,
          ProfileImage: result.profileImage,
          Role: roleName,
        });
      } else {
        console.error("Failed to fetch user data");
      }
    } catch (err) {
      console.error("Error fetching user data:", err);
    }
  };

  const sanitizeInput = () => {
    return {
      userId: userData.UserId,
      profileImage: DOMPurify.sanitize(userData.ProfileImage),
      userName: DOMPurify.sanitize(userData.UserName),
      userEmail: DOMPurify.sanitize(userData.Email),
      userPhoneNumber: DOMPurify.sanitize(userData.PhoneNumber),
    };
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUserData((prev) => ({ ...prev, [name]: value }));

    setFormErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const handleChangeImage = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    try {
      const options = {
        maxSizeMB: 1,
        maxWidthOrHeight: 1024,
        useWebWorker: true,
      };

      const compressedFile = await imageCompression(file, options);

      const base64 = await convertToBase64(compressedFile);

      setUserData((prev) => ({
        ...prev,
        ProfileImage: base64,
      }));
    } catch (err) {
      console.error("Error compressing image:", err);
    }
  };

  const convertToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;

      reader.readAsDataURL(file);
    });
  };

  const handleSubmit = async () => {
    // checking form validation before submit
    const Data = {
      userName: userData.UserName,
      email: userData.Email,
      mobileNo: userData.PhoneNumber,
    };
    const { isValid, errors } = validateForm(Data);
    if (!isValid) {
      setFormErrors((prev) => ({
        ...prev,
        UserName: errors.userName || "",
        Email: errors.email || "",
        PhoneNumber: errors.mobileNo || "",
      }));
      return;
    }

    // proceed with API call if form is valid

    try {
      const response = await UpdateUserProfile(sanitizeInput());
      console.log("Update response:", response);
      if (response?.data?.result === 1) {
        toast.success("Profile updated successfully!");
        setIsUpdated(true);
        setIsProfileUpdated(true);
      } else if (response?.data?.result === 0) {
        toast.error(response.data.message || "Failed to update profile");
        setIsUpdated(true);
      } else {
        console.error("Failed to fetch user data");
      }
    } catch (err) {
      console.error("Error fetching user data:", err);
    } finally {
      setIsUpdated(false);
    }
  };

  const updateNewPassword = async (e) => {

    e.preventDefault();

    const isEmpty = (value) => !value || value.trim() === "";

    if (passwordStatus?.result === false) {
      toast.error("Password is weak. Please follow the guidelines.");
      return;
    } else if (
      isEmpty(changePasswordData.confirmNewPassword) ||
      isEmpty(changePasswordData.newPassword) ||
      isEmpty(changePasswordData.currentPassword)
    ) {
      toast.error("Please fill all required fields");
      return;
    }
    else if (
      changePasswordData.confirmNewPassword !== changePasswordData.newPassword
    ) {
      toast.warning("New password and confirm password did not match");
      return;
    }

    const payload = {
      email: userData.Email,
      oldpassword: changePasswordData.currentPassword,
      newpassword: changePasswordData.confirmNewPassword,
    };

    setisProcessing(true);
    try {
      const response = await ChangePasswordByOldPassword(payload);
      if (response.data.result === 1) {
        toast.success(response.data.result_value);
        setChangePasswordData({
          currentPassword: "",
          newPassword: "",
          confirmNewPassword: "",
        });
        setIsChangePasswordModalOpen(false);
        return;
      } else if (response.data.result === -2) {
        toast.error(response.data.result_value);
        return;
      } else if (response.data.result === 0) {
        toast.error(response.data.error_value.errorText);
        return;
      }
    } catch (error) {
      toast.error("Something went wrong. Please try again later.");
    }
    finally {

      setisProcessing(false);
      setPasswordStatus({
        msg: null,
        result: null,
        color: null,
      });

      setStatusConfirmPassword({
        msg: null,
        result: null,
        color: null,
      });
    }
  };

  const cancleChangePassword = () => {
    setChangePasswordData({
      currentPassword: "",
      newPassword: "",
      confirmNewPassword: "",
    });
    setPasswordStatus({
      msg: null,
      result: null,
      color: null,
    });

    setStatusConfirmPassword({
      msg: null,
      result: null,
      color: null,
    });
    setIsChangePasswordModalOpen(false);
  };

  const handleChangePasswordData = (e) => {
    setShowPasswordStatus(true);
    const { name, value } = e.target;
    setChangePasswordData((prev) => ({ ...prev, [name]: value }));

    // Check strength only for the password field
    if (name === "newPassword") {
      const passwordStrength = checkPasswordStrength("", value);
      setPasswordStatus(passwordStrength);
    } else if (name === "confirmNewPassword") {
      const passwordStrength = checkPasswordStrength("", value);
      setStatusConfirmPassword(passwordStrength);
    }
  };

  const togglePassword = (e) => {
    let name = e;
    if (name === "showCurrentPassword") {
      setShowPasswordVisibility((prev) => ({
        ...prev,
        showCurrentPassword: !prev.showCurrentPassword,
      }));
    } else if (name === "showConfirmPassword") {
      setShowPasswordVisibility((prev) => ({
        ...prev,
        showConfirmPassword: !prev.showConfirmPassword,
      }));
    } else if (name === "showNewPassword") {
      setShowPasswordVisibility((prev) => ({
        ...prev,
        showNewPassword: !prev.showNewPassword,
      }));
    }
  };

  const handleModalResponse = async (choice) => {
    setshowWarningModal(false);
    if (choice == "no") {
      return;
    } else if (choice == "yes") {
      handleSubmit();
    }
  };

  const openPasswordModal = () => {
    setIsChangePasswordModalOpen(true)
  }


  return (
    <>
      <section className="profile-container">
        {/* Profile Card */}
        <div className="profile-card">
          <div className="card_header">
            <h2>Profile Summary</h2>
          </div>

          <div className="card_body center-text">
            <div className="avatar-upload">
              <img
                src={userData.ProfileImage || accountSvg}
                alt="Profile"
                id="profilePic"
              />
              <label for="fileInput">
                <i class="bi bi-camera-fill"></i>
              </label>
              <input
                type="file"
                id="fileInput"
                hidden
                onChange={handleChangeImage}
              />
            </div>

            <h3>{userData.UserName}</h3>
            <p className="role">
              Role : <span>{userData.Role}</span>
            </p>
          </div>
        </div>

        {/* Details Card */}
        <div className="details-card">
          <div className="card_header">
            <h2>Account Settings</h2>
          </div>

          <div className="card_body">
            <form className="profile-form">
              <div className="form-group">
                <label>User Name</label>
                <input
                  type="text"
                  name="UserName"
                  value={userData.UserName}
                  onChange={handleChange}
                />
              </div>
              {formErrors.UserName && (
                <p className="validation-error">{formErrors.UserName}</p>
              )}

              <div className="form-group">
                <label>Email</label>
                <input type="text" value={userData.Email} readOnly />
              </div>
              {formErrors.Email && (
                <p className="validation-error">{formErrors.Email}</p>
              )}

              <div className="form-group">
                <label>Mobile Number</label>
                <input
                  type="tel"
                  name="PhoneNumber"
                  placeholder="Enter mobile number"
                  value={userData.PhoneNumber}
                  onChange={handleChange}
                  minLength={10}
                  maxLength={10}
                  pattern="[0-9]{10}"
                />
                {formErrors.PhoneNumber && (
                  <p className="validation-error">{formErrors.PhoneNumber}</p>
                )}
              </div>

              <div className="form-actions_btn">
                <button
                  type="button"
                  className="primary_btn"
                  onClick={() => { setshowWarningModal(true); }}
                >
                  Update Profile
                </button>

                <button
                  type="button"
                  className="primary_btn"
                  onClick={openPasswordModal}
                >
                  Change Password
                </button>
              </div>
            </form>
          </div>
        </div>
      </section>

      {/* {isChangePasswordModalOpen && ( */}
      <div className={`modal_overlay ${isChangePasswordModalOpen ? "showModalBox" : ""}`}>
        <div className="modal">
          <div className="modal_header">
            <div className="modal_header_text">
              <h2>Change Password</h2>
            </div>
            <div className="modal_cross_icon" onClick={() => cancleChangePassword()}>
              <i className="bi bi-x-lg"></i>
            </div>
          </div>

          <div className="modal_body">
            <form className="profile-form">
              <div className="">
                <div className="p-relative">
                  <label className="label">
                    Current Password<span>*</span>
                  </label>
                  <input
                    type={
                      showPasswordVisibility.showCurrentPassword
                        ? "text"
                        : "password"
                    }
                    className="form-control profile-form-control"
                    name="currentPassword"
                    placeholder="Enter your current password"
                    value={changePasswordData.currentPassword || ""}
                    onChange={handleChangePasswordData}
                    required
                  />
                  <span
                    className="password-toggle-icon1"
                    name="showCurrentPassword"
                    onClick={() => togglePassword("showCurrentPassword")}
                  >
                    <FontAwesomeIcon
                      style={{ fontSize: "14px" }}
                      icon={
                        !showPasswordVisibility.showCurrentPassword
                          ? faEyeSlash
                          : faEye
                      }
                    />
                  </span>
                </div>

                <div className="p-relative">
                  <label className="label">
                    New Password<span>*</span>
                  </label>
                  <input
                    type={
                      showPasswordVisibility.showNewPassword
                        ? "text"
                        : "password"
                    }
                    className="form-control profile-form-control"
                    name="newPassword"
                    placeholder="Enter your new password"
                    value={changePasswordData.newPassword || ""}
                    onChange={handleChangePasswordData}
                    required
                  />
                  <span
                    className="password-toggle-icon2"
                    onClick={() => togglePassword("showNewPassword")}
                  >
                    <FontAwesomeIcon
                      style={{ fontSize: "14px" }}
                      icon={
                        !showPasswordVisibility.showNewPassword
                          ? faEyeSlash
                          : faEye
                      }
                    />
                  </span>
                  <div>
                    {showPasswordStatus && (
                      <span
                        style={{
                          color: passwordStatus?.color || "white",
                          marginRight: "0px",
                          fontWeight: 400,
                          marginTop: "4px",
                          display: "block"
                        }}
                      >
                        {passwordStatus?.msg}
                      </span>
                    )}
                  </div>
                </div>

                <div className="p-relative">
                  <label className="label">
                    Confirm New Password<span>*</span>
                  </label>
                  <input
                    type={
                      showPasswordVisibility.showConfirmPassword
                        ? "text"
                        : "password"
                    }
                    className="form-control profile-form-control"
                    name="confirmNewPassword"
                    placeholder="Enter your new password again for confirmation"
                    value={changePasswordData.confirmNewPassword || ""}
                    onChange={handleChangePasswordData}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        updateNewPassword(e);
                      }
                    }}
                    required
                  />
                  <span
                    className="password-toggle-icon2"
                    onClick={() => togglePassword("showConfirmPassword")}
                  >
                    <FontAwesomeIcon
                      style={{ fontSize: "14px" }}
                      icon={
                        !showPasswordVisibility.showConfirmPassword
                          ? faEyeSlash
                          : faEye
                      }
                    />
                  </span>
                  <div>
                    {showPasswordStatus && (
                      <span
                        style={{
                          color: StatusConfirmPassword?.color || "white",
                          marginRight: "0px",
                          fontWeight: 400,
                          marginTop: "4px",
                          display: "block"
                        }}
                      >
                        {StatusConfirmPassword?.msg}
                      </span>
                    )}
                  </div>
                </div>
              </div>
              <div className="form-actions_cancle_btn">
                <button
                  type="button"
                  disabled={isProcessing}
                  className="delete_approve_btn"
                  onClick={updateNewPassword}
                >
                  {isProcessing ? <div className="spinner"></div> : "Update Password"}
                </button>

                <button
                  type="button"
                  className="delete_reject_btn"
                  onClick={() => cancleChangePassword()}
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>


      {showWarningModal && (
        <ConfirmModal
          title="Action Required"
          message="Are you sure you want to save your changes?"
          confirmText="Yes, I'm Sure"
          cancelText="Cancel"
          onClose={handleModalResponse}
        />
      )}
    </>
  );
}

export default Profile;
